export default __webpack_public_path__ + "static/media/icn_hamburger_v2.4e5716e5.svg";